import {
    call, put, all, takeLatest, spawn, select,
} from 'redux-saga/effects';
import Api from '../services/ApiManager';
import { execSaveRequest, Options } from './effects';
import { saveFlowAction } from '../actions/flowActions';
import { FlowActionTypes, saveFlowActionType } from '../../model/workflowEditor/flow/actions';

function* saveFlow(action: FlowActionTypes) {
    const options: Options = {
      payload: action.payload,
      successMessage: 'Worklow sauvegardée avec succès'
    };
    yield call(execSaveRequest, 
      Api.flows.create,
      Api.flows.update,
      saveFlowAction.success,
      saveFlowAction.failure,
      options);
  }

export function* startFlowsSagas() {
    yield all([
        takeLatest(saveFlowActionType.request, saveFlow),
    ]);
}